export const faqQuestions = [
  { id: 1, step: 'UserWaitingApproval', text: 'What kind of email I’m waiting for?' },
  {
    id: 2,
    step: 'UserGettingRegionalAccess',
    text: 'How to set up dual factor authentication?'
  },
  {
    id: 3,
    step: 'UserGettingRegionalAccess',
    text: 'How to request regional/above property access?'
  },
  { id: 4, step: 'UserGettingRegionalAccess', text: 'How to set security questions?' },
  {
    id: 5,
    step: 'Completed',
    text: 'How to create the reports for GXP?'
  }
]
